import React from 'react';
import PropTypes from 'prop-types';
import MultiPicker from './MultiPicker';

const MultiPickerFormik = ({
  options,
  field: { name, value },
  form: { setFieldValue = () => {}, isSubmitting = false },
  ...others
}) => {
  const onChange = newValue => setFieldValue(name, newValue);
  return (
    <MultiPicker
      options={options}
      selected={value}
      onChange={onChange}
      disabled={isSubmitting}
      {...others}
    />
  );
};

MultiPickerFormik.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.array,
  }).isRequired,
  form: PropTypes.shape({
    setFieldValue: PropTypes.func,
    isSubmitting: PropTypes.bool,
  }),
};

MultiPickerFormik.defaultProps = {
  form: {
    setFieldValue: () => {},
    isSubmitting: false,
  },
};

export default MultiPickerFormik;
